import React from 'react';
import { TableCellProps } from '../../../types/search';
import { formatDate } from '../utils/tableCellUtils';

const PortalCellDateDue: React.FC<TableCellProps> = ({ value, row, listingType }) => {
  return (
    <div className={`portal-cell portal-cell--${listingType} portal-cell--date-due`}>
      <p className="portal-cell__mobile-label">Due</p>
      <p>{formatDate(value)}</p>
    </div>
  );
};

export default PortalCellDateDue;
